import { NgModule } from '@angular/core';
import { SafeUrlPipe } from './safe-url/safe-url.pipe';
import { CalculateAgePipe } from './calculate-age/calculate-age.pipe';
import { NormalizeUrlPipe } from './normalize-url/normalize-url.pipe';
import { LocalizedDatePipe } from './Localized-date/localized-date.pipe';
import { DateAgoPipe } from './date-ago/date-ago.pipe';
import { FilterPipe } from './filter/filter.pipe';
// import { LinkifyPipe } from './linkify/linkify.pipe';

@NgModule({
    declarations: [
        SafeUrlPipe,
        CalculateAgePipe,
        LocalizedDatePipe,
        NormalizeUrlPipe,
        DateAgoPipe,
        FilterPipe,
        // LinkifyPipe
    ],
    imports: [],
    exports: [
        SafeUrlPipe,
        CalculateAgePipe,
        LocalizedDatePipe,
        NormalizeUrlPipe,
        DateAgoPipe,
        FilterPipe
        // LinkifyPipe
    ]
})
export class PipesModule {
}
